import cx from "classnames";

interface Props {
  status: string;
  className?: string;
}

const StatusBadge = ({ status, className }: Props) => {
  const statusLower = status.toLowerCase().trim();
  const badgeClass = cx("status-badge", {
    "status-badge--paid": statusLower === "paid",
    "status-badge--invoiced": statusLower === "invoiced",
    "status-badge--not-fully-paid": statusLower.includes("not fully"),
    "status-badge--pending": statusLower === "pending",
    "status-badge--unpaid": statusLower === "unpaid",
    "status-badge--pickinginprogress": statusLower === "pickinginprogress",
    className,
  });

  const displayStatus = statusLower === "pickinginprogress" ? "PICKING IN PROGRESS" : status;

  return <span className={badgeClass}>{displayStatus}</span>;
};

export default StatusBadge;
